import React from "react";
import Button from "@surgia/ui/components/button";
import SidebarModal from "@surgia/ui/components/Modals/SidebarModal";
import CartItem from "../../components/cartItem";
import { useSubmitPurchaseRequest } from "../../hooks/useSubmitPurchaseRequest";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { permissions } from "../../permissions";

// Icons
import closeIcon from "@surgia/ui/icons/popup/close.svg";

// Constants
import { PurchaseCartModalProps } from "./constant";
import { getLocalStorageItem } from "../../pages/Catalog";
const PurchaseCartModal: React.FC<PurchaseCartModalProps> = ({
  open,
  onClose,
  cartItems = [],
  draftPurchaseRequestID,
  branchId,
}) => {
  const tenantId = getLocalStorageItem("tenant_id", null);
  const submitPurchaseRequestMutation = useSubmitPurchaseRequest({
    branchId: branchId?.toString() || "",
    componentId: import.meta.env.VITE_PUBLIC_COMPONENT_ID || "",
    tenantId: tenantId?.toString() || "",
  });

  const userPermissions = useSelector(
    (state: RootState) =>
      state.auth.globalState.user_permissions?.map(
        (permission) => permission.name
      ) || []
  );

  const handleSubmitPurchaseRequest = async () => {
    try {
      await submitPurchaseRequestMutation.mutateAsync({
        id: draftPurchaseRequestID.toString(),
        componentId: import.meta.env.VITE_PUBLIC_COMPONENT_ID || "",
        tenantId: tenantId?.toString() || "",
        branchId: branchId.toString(),
      });
      onClose();
    } catch (error) {
      console.error("Failed to submit purchase request:", error);
    }
  };

  return (
    <SidebarModal open={open} onClose={onClose}>
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex items-center justify-between py-2 px-4">
          <h2 className="text-[18px] font-semibold text-gray-900">
            Purchase request
          </h2>
          <button onClick={onClose} className="rounded-lg transition-colors">
            <img src={closeIcon} alt="Close" />
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
          {cartItems.length > 0 ? (
            cartItems.map((item) => (
              <CartItem
                key={item?.tenant_product?.id}
                item={item}
                branchId={branchId?.toString()}
                tenantId={tenantId?.toString()}
              />
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">Your cart is empty</p>
            </div>
          )}
        </div>

        {/* Footer with Submit Button */}
        <div className="p-6">
          <Button
            variant="purple"
            onClick={handleSubmitPurchaseRequest}
            disabled={
              cartItems.length === 0 ||
              submitPurchaseRequestMutation.isPending ||
              !userPermissions.includes(permissions.EDIT_DRAFT_PURCHASE_REQUEST)
            }
            className="w-full !bg-[#7144FF]"
          >
            {submitPurchaseRequestMutation.isPending ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin "></div>
                Submitting...
              </div>
            ) : (
              "Submit purchase request (PR)"
            )}
          </Button>
        </div>
      </div>
    </SidebarModal>
  );
};

export default PurchaseCartModal;
